export const mapScoreToSeverity = (score) => {
    if (score < 30) {
        return "critical";
    }
    if (score < 60) {
        return "high";
    }
    if (score < 80) {
        return "medium";
    }
    return "low";
};
export const sumProbeAttacks = (splxRisks) => {
    return Object.values(splxRisks).reduce((categorySum, assessments) => {
        const categoryAttacks = Object.values(assessments).reduce((probeSum, probes) => {
            const probeAttacks = Object.values(probes).reduce((testAttackCounts, test) => {
                testAttackCounts.probesTotalAttacks += test.test_count;
                testAttackCounts.probesSuccessfulAttacks += test.test_fails;
                return testAttackCounts;
            }, { probesTotalAttacks: 0, probesSuccessfulAttacks: 0 });
            probeSum.categoryTotalAttacks += probeAttacks.probesTotalAttacks;
            probeSum.categorySuccessfulAttacks +=
                probeAttacks.probesSuccessfulAttacks;
            return probeSum;
        }, { categoryTotalAttacks: 0, categorySuccessfulAttacks: 0 });
        categorySum.totalAttacks += categoryAttacks.categoryTotalAttacks;
        categorySum.successfulAttacks +=
            categoryAttacks.categorySuccessfulAttacks;
        return categorySum;
    }, { totalAttacks: 0, successfulAttacks: 0 });
};
//# sourceMappingURL=utils.js.map